import Logout from '../components/Logout'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { handleLogout } from '../modules/logout'

const mapStateToProps = state => ({
})

const mapDispatchToProps = dispatch => bindActionCreators({
  handleLogout
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Logout)



// WEBPACK FOOTER //
// ./src/routes/logout/containers/LogoutContainer.js